import {isApp, isLogged, mobileBreakPoint, config} from './utils.js';
import * as $ from 'jquery';

const countdown = (remainingTime, selectorId) => {
    const interval = 37, //in milliseconds
        countdown = setInterval(function() {
            var days = Math.floor(remainingTime / 864e5),
                hours = Math.floor(remainingTime % 864e5 / 36e5),
                minutes = Math.floor(remainingTime % 36e5 / 6e4),
                seconds = Math.floor(remainingTime % 6e4 / 1e3);
            days = days > 0 ? "<span class='numeros'>" + days.toLocaleString("es", {minimumIntegerDigits: 2, useGrouping: !1}) + "</span><span class='texto'>d</span> " : "";
            const countDownElem = document.querySelector("#" + selectorId);
            if (countDownElem) {
                countDownElem.innerHTML =
                    "<h2>" + days +
                        "<span class='numeros'>" + hours.toLocaleString("es", {minimumIntegerDigits: 2, useGrouping: !1}) + ":</span>" +
                        "<span class='numeros'>" + minutes.toLocaleString("es", {minimumIntegerDigits: 2, useGrouping: !1}) + ":</span>" +
                        "<span class='numeros'>" + seconds.toLocaleString("es", {minimumIntegerDigits: 2, useGrouping: !1}) + "</span>" +
                    "</h2>";
            }
            if (remainingTime < 0) {
                clearInterval(countdown);
                if (countDownElem) {
                    countDownElem.innerHTML = "";
                }
                document.querySelector('body').classList.remove('has-countdown');
            }
            remainingTime = remainingTime - interval;
        }, interval);
    document.querySelector('body').classList.add('has-countdown');
};

const countdownTextAlternator = () => {
    const $first = $('#js-countdown-first-txt');
    if(!$first.length){
        return;
    }
    const $second = $('#js-countdown-second-txt'),
        firstTxt = $first.text(),
        secondTxt = $second.text();

    if ($(window).width() <= mobileBreakPoint) {
        $first.fadeOut(function(){$(this).text(secondTxt)}).fadeIn();
        $second.text(firstTxt);
    } else {
        $first.text($first.data('text'));
        $second.text($second.data('text'));
    }
    setTimeout(countdownTextAlternator, 4000);
};


const getUserPromo = () => {
    const promo = config?.segmentPromo;
    if(!promo) {
        return null;
    }
    let [ end, text, shippingCost, minPrice, onlyPowerClothes, text2 ] = promo;
    if(new Date() > new Date(parseInt(end) * 1000)){
        return null;
    }
    return {
        end : end,
        text : text,
        ...text2 && {text2},
        shippingCost: parseFloat(shippingCost||0),
        minPrice: parseFloat(minPrice||0),
        onlyPowerClothes: parseInt(onlyPowerClothes)
    };

};

const showHeaderPromo = async (promo) => {
    const promoHeader = document.getElementById('header-promo');
    if(promo){
        const userPromoHeader = document.getElementById('user-promo-header');
        if(userPromoHeader){
            if(promoHeader){ //borrar header de promo normal
                promoHeader.parentNode.removeChild(promoHeader);
            }
            const banner = document.adoptNode(userPromoHeader.content);
            banner.getElementById('header-countdown').dataset.remainingTime = (parseInt(promo.end) * 1000) - (new Date()).getTime();
            const text = banner.querySelector('.js-text');
            text.textContent = promo.text;

             // For a promo (first buy) we show special format with two lines (GOT-810)
             if (promo.text2) {
                const wrapperText = banner.querySelector('.js-wrapper-text');
                const text2 = document.createElement("strong");
                text.id = "js-countdown-first-txt";
                text.dataset.text = promo.text;
                text2.id = "js-countdown-second-txt";
                text2.className = "caption-md text-uppercase js-text2 d-none d-lg-inline";
                text2.dataset.text =  promo.text2;
                text2.textContent = promo.text2;
                wrapperText.appendChild(text2);
            }
            document.querySelector('body').prepend(banner);
            return;
        }
    }
    if(promoHeader && !isApp()){ //Si hemos llegado aquí, es q no hemos podido mostrar promo de user, mostrar la normal
        promoHeader.classList.remove('d-none');
    }
};

const promo = isLogged() ? getUserPromo() : null;

window.addEventListener('DOMContentLoaded', async (event) => {
    if (isApp()) {
        return;
    }

    showHeaderPromo(promo);
    document.querySelectorAll('.js-countdown').forEach(elem => {
        if (!elem || !elem.id) return;
        countdown(elem.dataset.remainingTime, elem.id);
    });
    countdownTextAlternator();
});